import { render } from "./huanxunIncomeReport.vue?vue&type=template&id=08857107&scoped=true&ts=true"
import script from "./huanxunIncomeReport.vue?vue&type=script&lang=ts"
export * from "./huanxunIncomeReport.vue?vue&type=script&lang=ts"

import "./huanxunIncomeReport.vue?vue&type=style&index=0&id=08857107&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08857107"]])

export default __exports__